"use strict";
import { PortfolioLogo } from "components/AccountDrawer/MiniPortfolio/PortfolioLogo";
import { NATIVE_CHAIN_ID } from "constants/tokens";
import { gqlToCurrency } from "graphql/data/util";
import useNativeCurrency from "lib/hooks/useNativeCurrency";
import { useMemo } from "react";
import { UniverseChainId } from "features/chains/types";
import { getChainIdFromChainUrlParam } from "utils/chainParams";
import { getTokenLogoUrl } from "constants/tokenLogos";
import { useTokenListLogoUrl } from "contexts/TokenListsContext";
function isTokenStat(token) {
  return "volume" in token;
}
export default function QueryTokenLogo(props) {
  const chainId = getChainIdFromChainUrlParam(props.token?.chain.toLowerCase()) ?? UniverseChainId.Mainnet;
  const isNative = props.token?.address === NATIVE_CHAIN_ID;
  const token = props.token;
  const tokenStat = token && isTokenStat(token) ? token : void 0;
  const gqlToken = token && !isTokenStat(token) ? token : void 0;
  const nativeCurrency = useNativeCurrency(chainId);
  const currency = isNative ? nativeCurrency : gqlToken ? gqlToCurrency({
    chain: gqlToken.chain,
    address: gqlToken.address,
    decimals: gqlToken.decimals,
    symbol: gqlToken.symbol,
    name: gqlToken.name,
    feeData: gqlToken.feeData ?? void 0
  }) : void 0;
  const tokenListLogoUrl = useTokenListLogoUrl(props.token?.address ?? void 0);
  const logoUrl = (gqlToken ? gqlToken.project?.logoUrl || getTokenLogoUrl(gqlToken.address || "") || tokenListLogoUrl : tokenStat?.logo || void 0 || getTokenLogoUrl(props.token?.address || "") || tokenListLogoUrl) ?? void 0;
  const currencies = useMemo(
    () => tokenStat && !isNative ? void 0 : [currency],
    [currency, isNative, tokenStat]
  );
  return <PortfolioLogo
    currencies={currencies}
    chainId={chainId}
    images={[logoUrl]}
    tokenSymbol={props.token?.symbol}
    tokenName={props.token?.name}
    {...props}
  />;
}
